import React, { useState, useRef, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { motion, AnimatePresence, useMotionValue, useSpring, useTransform } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import './WorkSection.css';


const canineHeroImg = 'https://ascentbw.com/Images/CanineCrown/CanineCover.webp';
const windplusImg = 'https://ascentbw.com/Images/Windplus/Full.webp';
const Mgr = 'https://ascentbw.com/Images/MGR/Mgr4.webp';
const feston = 'https://ascentbw.com/Images/Feston/cover.webp';
const atssCover = 'https://ascentbw.com/Images/Atss/cover.webp';
const aulphaCover = 'https://ascentbw.com/Images/Aulpha/cover.webp';
const plugzmartCover = 'https://ascentbw.com/Images/Plugzmart/Full1.webp';
const smileauraCover = 'https://ascentbw.com/Images/Smileaura/Full1.webp';
const gangaSweetsCover = 'https://ascentbw.com/Images/Gangasweets/Full1.webp';
const velammalnexuxCover = 'https://ascentbw.com/Images/VelammalNexux/Full5.webp';
const swathyCover = 'https://ascentbw.com/Images/Swathy/Full3.webp';
const jkbCover = 'https://ascentbw.com/Images/JKB/Full1.webp';
const apramattCover = 'https://ascentbw.com/Images/Apramatt/Full2.webp';
const deyeCover = 'https://ascentbw.com/Images/Deye/Full1.webp';
const aiwoCover = 'https://ascentbw.com/Images/Aiwo/Full1.webp';

const workItems = [
  {
    id: 0,
    title: 'Ganga Sweets – Packaging & Brand Identity',
    category: ['Branding','Print & Signage'],
    size: 'standard',
    morph: 'bottom-right',
    img: gangaSweetsCover,
    link: '/works/gangasweets'
  },
  {
    id: 1,
    title: 'Canine Crown',
    category: ['Branding','Website','Media Production', 'Print & Signage'],
    size: 'standard',
    morph: 'bottom-right',
    img: canineHeroImg,
    websiteImg: 'https://ascentbw.com/Images/CanineCrown/Hero1.webp',
    websiteUrl: 'https://caninecrown.in',
    link: '/works/canine-crown'
  },
  {
    id: 2,
    title: 'Feston – Renewable Energy Brand Experience',
    category: ['Branding', 'Media Production'],
    size: 'standard',
    morph: 'bottom-right',
    img: feston,
    link: '/works/feston'
  },
  {
    id: 3,
    title: 'MGR - University',
    category: 'Branding',
    size: 'standard',
    morph: 'bottom-right',
    img: Mgr,
    link: '/works/mgr'
  },
  {
    id: 4,
    title: 'ATSS Technologies – Security & Automation Solutions',
    category: ['Branding','Print & Signage'],
    size: 'standard',
    morph: 'bottom-right',
    img: atssCover,
    link: '/works/atss'
  },
  {
    id: 5,
    title: 'Aulpha Technologies – Corporate Identity & Print Collaterals',
    category: ['Branding','Print & Signage'],
    size: 'standard',
    morph: 'bottom-right',
    img: aulphaCover,
    link: '/works/aulpha'
  },
  {
    id: 6,
    title: 'Plugzmart – Smart EV Charging Solutions',
    category: 'Media Production',
    size: 'standard',
    morph: 'bottom-right',
    img: plugzmartCover,
    link: '/works/plugzmart'
  },
  {
    id: 9,
    title: 'Velammal Nexus – Newspaper Ads & Billboards',
    category: 'Print & Signage',
    size: 'standard',
    morph: 'bottom-right',
    img: velammalnexuxCover,
    link: '/works/velammalnexux'
  },
  {
    id: 11,
    title: 'JKB – Billboard & Brochure Design',
    category: 'Print & Signage',
    size: 'standard',
    morph: 'bottom-right',
    img: jkbCover,
    link: '/works/jkb'
  },
  {
    id: 13,
    title: 'Deye – Clean Energy & Smart Solar Branding',
    category: ['Branding','Print & Signage'],
    size: 'standard',
    morph: 'bottom-right',
    img: deyeCover,
    link: '/works/deye'
  },
  {
    id: 14,
    title: 'AIWO Health – Premium Supplement Packaging',
    category: ['Branding','Print & Signage'],
    size: 'standard',
    morph: 'bottom-right',
    img: aiwoCover,
    link: '/works/aiwo'
  },

  /* --- WEBSITE CARDS (ORDERED SPECIFICALLY AS REQUESTED) --- */
  {
    id: 15,
    title: 'Namma Veettu Kalyanam Catering',
    category: ['Website'],
    size: 'standard',
    morph: 'bottom-right',
    img: 'https://ascentbw.com/Images/NVK/NVK.webp',
    websiteImg: 'https://ascentbw.com/Images/NVK/NVK.webp',
    websiteUrl: 'https://nammaveettukalyanamcatering.com/',
    link: '/works'
  },
  {
    id: 24,
    title: 'Refmax',
    category: ['Website'],
    size: 'standard',
    morph: 'bottom-right',
    img: 'https://ascentbw.com/Images/Refmax/WebImg.webp',
    websiteImg: 'https://ascentbw.com/Images/Refmax/WebImg.webp',
    websiteUrl: 'https://refmax.co.in/',
    link: '/works'
  },
  {
    id: 16,
    title: 'Prime Rehab',
    category: ['Website'],
    size: 'standard',
    morph: 'bottom-right',
    img: 'https://ascentbw.com/Images/PrimeRehab/WebImg.webp',
    websiteImg: 'https://ascentbw.com/Images/PrimeRehab/WebImg.webp',
    websiteUrl: 'https://primerehabindustries.in/',
    link: '/works'
  },
  {
    id: 25,
    title: 'Kidzee Padur',
    category: ['Website'],
    size: 'standard',
    morph: 'bottom-right',
    img: 'https://ascentbw.com/Images/Kidzee/WebImg.webp',
    websiteImg: 'https://ascentbw.com/Images/Kidzee/WebImg.webp',
    websiteUrl: 'https://kidzeepadur.com/',
    link: '/works'
  },
  {
    id: 17,
    title: 'Madhi Academy',
    category: ['Website'],
    size: 'standard',
    morph: 'bottom-right',
    img: 'https://ascentbw.com/Images/MadhiAcademy/WebImg.webp',
    websiteImg: 'https://ascentbw.com/Images/MadhiAcademy/WebImg.webp',
    websiteUrl: 'https://madhiacademy.com/',
    link: '/works'
  },
  {
    id: 10,
    title: 'Swathy Foundation',
    category: ['Branding','Website'],
    size: 'standard',
    morph: 'bottom-right',
    img: swathyCover,
    websiteImg: 'https://ascentbw.com/Images/Swathy/Full3.webp',
    websiteUrl: 'https://www.shriswathyfoundations.com/',
    link: '/works/swathy'
  },
  {
    id: 18,
    title: 'Vinayas Electronics',
    category: ['Website'],
    size: 'standard',
    morph: 'bottom-right',
    img: 'https://ascentbw.com/Images/VinayasElectronics/WebImg.webp',
    websiteImg: 'https://ascentbw.com/Images/VinayasElectronics/WebImg.webp',
    websiteUrl: 'https://vinyaselectronics.in/',
    link: '/works'
  },
  {
    id: 19,
    title: 'Best for Pets',
    category: ['Website'],
    size: 'standard',
    morph: 'bottom-right',
    img: 'https://ascentbw.com/Images/BestforPet/WebImg.webp',
    websiteImg: 'https://ascentbw.com/Images/BestforPet/WebImg.webp',
    websiteUrl: 'https://www.bestforpet.in/',
    link: '/works'
  },
  {
    id: 8,
    title: 'Windplus',
    category: ['Website','Print & Signage'],
    size: 'standard',
    morph: 'top',
    img: windplusImg,
    websiteImg: 'https://ascentbw.com/Images/Windplus/Full.webp',
    websiteUrl: 'https://windpluseagle.in/',
    link: '/works/windplus'
  },
  {
    id: 20,
    title: 'Dynamic Stamping',
    category: ['Website'],
    size: 'standard',
    morph: 'bottom-right',
    img: 'https://ascentbw.com/Images/DynamicStamping/WebImg.webp',
    websiteImg: 'https://ascentbw.com/Images/DynamicStamping/WebImg.webp',
    websiteUrl: 'https://dynamicstamping.in/',
    link: '/works'
  },
  {
    id: 21,
    title: 'Grenel Powers',
    category: ['Website'],
    size: 'standard',
    morph: 'bottom-right',
    img: 'https://ascentbw.com/Images/GrenelPowers/WebImg.webp',
    websiteImg: 'https://ascentbw.com/Images/GrenelPowers/WebImg.webp',
    websiteUrl: 'https://www.grenelpowers.com/',
    link: '/works'
  },
  {
    id: 26,
    title: 'Black Salt',
    category: ['Website'],
    size: 'standard',
    morph: 'bottom-right',
    img: 'https://ascentbw.com/Images/BlackSalt/WebImg.webp',
    websiteImg: 'https://ascentbw.com/Images/BlackSalt/WebImg.webp',
    websiteUrl: 'https://blacksalt.in/',
    link: '/works'
  },
  {
    id: 12,
    title: 'Apramatt',
    category: ['Branding','Website','Media Production'],
    size: 'standard',
    morph: 'bottom-right',
    img: apramattCover,
    websiteImg: 'https://ascentbw.com/Images/Apramatt/Full1.webp',
    websiteUrl: 'https://apramatt.com/',
    link: '/works/apramatt'
  },
  {
    id: 27,
    title: 'Tag Nxt',
    category: ['Website'],
    size: 'standard',
    morph: 'bottom-right',
    img: 'https://ascentbw.com/Images/TagNxt/WebImg.webp',
    websiteImg: 'https://ascentbw.com/Images/TagNxt/WebImg.webp',
    websiteUrl: 'https://tagnxt.in/',
    link: '/works'
  },
  {
    id: 7,
    title: 'Smile Aura Dental Studio',
    category: ['Branding','Website','Media Production'],
    size: 'standard',
    morph: 'bottom-right',
    img: smileauraCover,
    websiteImg: 'https://ascentbw.com/Images/Smileaura/Full3.webp',
    websiteUrl: 'https://smileauradentalstudio.com/',
    link: '/works/smileaura'
  },
  {
    id: 23,
    title: 'MK Auto Components',
    category: ['Website'],
    size: 'standard',
    morph: 'bottom-right',
    img: 'https://ascentbw.com/Images/MKAuto/WebImg.webp',
    websiteImg: 'https://ascentbw.com/Images/MKAuto/WebImg.webp',
    websiteUrl: 'https://www.mkautocomponents.com/',
    link: '/works'
  },
  {
    id: 22,
    title: 'HSN Digital Studios',
    category: ['Website'],
    size: 'standard',
    morph: 'bottom-right',
    img: 'https://ascentbw.com/Images/HSNDigital/WebImg.webp',
    websiteImg: 'https://ascentbw.com/Images/HSNDigital/WebImg.webp',
    websiteUrl: 'https://hsndigitalstudios.com/',
    link: '/works'
  }
];


export const TiltCard = ({ item, activeFilter }) => {
  const navigate = useNavigate();
  const cardRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Show "Visit Site" button ONLY when the active filter tab is 'Website'
  const isWebCategory = Array.isArray(item.category)
    ? item.category.includes('Website') || item.category.includes('Web & Apps')
    : item.category === 'Website' || item.category === 'Web & Apps';
  const showVisitSite = activeFilter === 'Website' && isWebCategory && item.websiteUrl;
  
  // Use specific website screenshot image when active filter is Website, otherwise standard cover image
  const currentImg = (activeFilter === 'Website' && item.websiteImg) ? item.websiteImg : item.img;

  const handleCardClick = () => {
    if (activeFilter === 'Website' && item.websiteUrl) {
      window.open(item.websiteUrl, '_blank', 'noopener,noreferrer');
    } else {
      navigate(item.link || '/works');
    }
  };

  // Motion values for tracking cursor relative positions on the 4 edges (0 to 1 range)
  const x = useMotionValue(0.5);
  const y = useMotionValue(0.5);

  const xSpring = useSpring(x, { damping: 20, stiffness: 150 });
  const ySpring = useSpring(y, { damping: 20, stiffness: 150 });
  const hoverSpring = useSpring(0, { damping: 20, stiffness: 150 });

  // Springs for 3D tilts (Max 12 degrees tilt)
  const rotateXSpring = useSpring(useTransform(y, [0, 1], [12, -12]), { damping: 25, stiffness: 180 });
  const rotateYSpring = useSpring(useTransform(x, [0, 1], [-12, 12]), { damping: 25, stiffness: 180 });

  // Parallax displacement for inside card contents
  const imgXSpring = useSpring(useTransform(x, [0, 1], [-8, 8]), { damping: 25, stiffness: 180 });
  const imgYSpring = useSpring(useTransform(y, [0, 1], [-8, 8]), { damping: 25, stiffness: 180 });

  const scaleSpring = useSpring(1, { damping: 25, stiffness: 200 });

  // 360-degree liquid morphing clipPath string using quadratic beziers
  const clipPathD = useTransform(
    [xSpring, ySpring, hoverSpring],
    ([mx, my, h]) => {
      // Helper to calculate pushed point away from cursor
      const getPushedPoint = (px, py, maxPush) => {
        if (h === 0) return { x: px, y: py };
        const dx = px - mx;
        const dy = py - my;
        const dist = Math.sqrt(dx * dx + dy * dy) || 0.001;
        const influence = 0.75;
        let push = Math.max(0, 1 - dist / influence);
        push = push * push * maxPush * h;

        return {
          x: px - (dx / dist) * push,
          y: py - (dy / dist) * push
        };
      };

      const r = 0.05;

      const tl_p1 = getPushedPoint(0, r, 0.08);
      const tl_c = getPushedPoint(0, 0, 0.12);
      const tl_p2 = getPushedPoint(r, 0, 0.08);

      const t_c = getPushedPoint(0.5, 0, 0.12);

      const tr_p1 = getPushedPoint(1 - r, 0, 0.08);
      const tr_c = getPushedPoint(1, 0, 0.12);
      const tr_p2 = getPushedPoint(1, r, 0.08);

      const r_c = getPushedPoint(1, 0.5, 0.12);

      const br_p1 = getPushedPoint(1, 1 - r, 0.08);
      const br_c = getPushedPoint(1, 1, 0.12);
      const br_p2 = getPushedPoint(1 - r, 1, 0.08);

      const b_c = getPushedPoint(0.5, 1, 0.12);

      const bl_p1 = getPushedPoint(r, 1, 0.08);
      const bl_c = getPushedPoint(0, 1, 0.12);
      const bl_p2 = getPushedPoint(0, 1 - r, 0.08);

      const l_c = getPushedPoint(0, 0.5, 0.12);

      return `M ${tl_p1.x} ${tl_p1.y} 
              Q ${tl_c.x} ${tl_c.y} ${tl_p2.x} ${tl_p2.y} 
              Q ${t_c.x} ${t_c.y} ${tr_p1.x} ${tr_p1.y} 
              Q ${tr_c.x} ${tr_c.y} ${tr_p2.x} ${tr_p2.y} 
              Q ${r_c.x} ${r_c.y} ${br_p1.x} ${br_p1.y} 
              Q ${br_c.x} ${br_c.y} ${br_p2.x} ${br_p2.y} 
              Q ${b_c.x} ${b_c.y} ${bl_p1.x} ${bl_p1.y} 
              Q ${bl_c.x} ${bl_c.y} ${bl_p2.x} ${bl_p2.y} 
              Q ${l_c.x} ${l_c.y} ${tl_p1.x} ${tl_p1.y} Z`;
    }
  );

  // Radial glint glare background
  const glareBg = useTransform(
    [x, y],
    ([latestX, latestY]) =>
      `radial-gradient(circle at ${latestX * 100}% ${latestY * 100}%, rgba(255, 255, 255, 0.18) 0%, rgba(255, 255, 255, 0) 75%)`
  );

  const handleMouseMove = (e) => {
    if (isMobile || !cardRef.current) return;
    const rect = cardRef.current.getBoundingClientRect();
    const width = rect.width;
    const height = rect.height;
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;

    const px = mouseX / width;
    const py = mouseY / height;
    x.set(px);
    y.set(py);
  };

  const handleMouseEnter = (e) => {
    if (isMobile) return;
    scaleSpring.set(0.95);
    hoverSpring.set(1);
    handleMouseMove(e);
  };

  const handleMouseLeave = () => {
    scaleSpring.set(1);
    hoverSpring.set(0);
    x.set(0.5);
    y.set(0.5);
  };

  return (
    <motion.div
      ref={cardRef}
      className={`work-item ${item.size}`}
      onMouseMove={handleMouseMove}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleCardClick}
      style={{
        perspective: 1200,
      }}
    >
      <svg width="0" height="0" style={{ position: 'absolute', pointerEvents: 'none' }}>
        <defs>
          <clipPath id={`clip-${item.id}`} clipPathUnits="objectBoundingBox">
            <motion.path d={clipPathD} />
          </clipPath>
        </defs>
      </svg>

      <motion.div
        className="work-card-inner"
        style={{
          rotateX: isMobile ? 0 : rotateXSpring,
          rotateY: isMobile ? 0 : rotateYSpring,
          scale: scaleSpring,
          clipPath: isMobile ? 'none' : `url(#clip-${item.id})`,
          transformStyle: 'preserve-3d',
        }}
      >
        <motion.div
          className="work-img-wrapper"
          style={{
            x: isMobile ? 0 : imgXSpring,
            y: isMobile ? 0 : imgYSpring,
            scale: isMobile ? 1 : 1.1,
            transformStyle: 'preserve-3d',
          }}
        >
          <img
            src={currentImg}
            alt={item.title}
            className="work-img"
            draggable="false"
          />
        </motion.div>

        {!isMobile && (
          <motion.div
            className="work-card-glare"
            style={{
              background: glareBg,
            }}
          />
        )}
      </motion.div>

      <div className="work-meta">
        <h4 className="work-card-title">{item.title}</h4>
        {showVisitSite && (
          <a
            href={item.websiteUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="visit-site-btn"
            onClick={(e) => e.stopPropagation()}
          >
            Visit Site
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: '6px' }}>
              <line x1="7" y1="17" x2="17" y2="7"></line>
              <polyline points="7 7 17 7 17 17"></polyline>
            </svg>
          </a>
        )}
      </div>
    </motion.div>
  );
};

const WorkSection = () => {
  const [filter, setFilter] = useState('All');

  const categories = [
    'All',
    'Branding',
    'Website',
    'Media Production',
    'Print & Signage',
    'Corporate Gifts'
  ];

  const isWebsiteOnly = (item) => {
    if (Array.isArray(item.category)) {
      return item.category.length === 1 && (item.category[0] === 'Website' || item.category[0] === 'Web & Apps');
    }
    return item.category === 'Website' || item.category === 'Web & Apps';
  };

  const filteredItems = filter === 'All'
    ? workItems.filter(item => !isWebsiteOnly(item))
    : workItems.filter(item => {
        if (Array.isArray(item.category)) {
          return item.category.includes(filter);
        }
        return item.category === filter;
      });

  return (
    <section className="work-section" id="work">
      <Container>
        <div className="work-header">


          <div className="filter-wrapper">
            {categories.map(cat => (
              <button
                key={cat}
                className={`filter-pill ${filter === cat ? 'active' : ''}`}
                onClick={() => setFilter(cat)}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        <motion.div layout className="work-grid">
          <AnimatePresence mode="popLayout">
            {filteredItems.map(item => (
              <motion.div
                layout
                key={item.id}
                initial={{ opacity: 0, scale: 0.96 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.96 }}
                transition={{ duration: 0.35, ease: 'easeOut' }}
                className={`work-grid-item-wrapper ${item.size}`}
              >
                <TiltCard item={item} activeFilter={filter} />
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </Container>
    </section>
  );
};

export default WorkSection;
